//@@ Libs
import { Row, Spinner } from 'reactstrap'

//@@ Utils
import { getOptionFromRawValue, getOptionsFromRawValues, getRawValueFromOption } from '@utils'

//@@ Constants
import { PLATFORM_CATEGORIES } from 'constants/apps'
import { CONGREGANTS_OPTIONS } from '@src/views/apps/reports/constants'

//@@ Components
import UILoader from '@components/ui-loader'
import { Characteristic } from '@src/views/apps/reports/components/Characteristic/Characteristic'
import { FormSelect } from '@src/views/apps/reports/components/FormElements/FormSelect'
import { FormBetweenRange } from '@src/views/apps/reports/components/FormElements/FormBetweenRange'
import { FormForTheseSelect } from '@src/views/apps/reports/components/FormElements/FormForTheseSelect'
import { AdaptiveLabel } from '@src/views/apps/reports/components/AdaptiveLabel/AdaptiveLabel'

//@@ Styles
import '@styles/react/libs/flatpickr/flatpickr.scss'

export const ParticipationForm = ({
  isLoading,
  settings,
  settingsDictionaries,
  onSettingChange,
  onCharacteristicChange,
  onCharacteristicAdd,
  onCharacteristicValueChange,
  onCharacteristicRemove
}) => {
  return (
    <>
      <UILoader loader={<Spinner />} blocking={isLoading}>
        <FormSelect
          isRequired
          value={getOptionFromRawValue({ rawValue: settings.showMeCategory, options: CONGREGANTS_OPTIONS })}
          options={CONGREGANTS_OPTIONS}
          label="Show Me The"
          onChange={(opt) => onSettingChange({ name: 'showMeCategory', value: getRawValueFromOption(opt) })}
        />

        <FormSelect
          isRequired
          value={getOptionFromRawValue({ rawValue: settings.participatedIn, options: PLATFORM_CATEGORIES })}
          options={PLATFORM_CATEGORIES}
          label="That Participated In"
          onChange={(opt) => onSettingChange({ name: 'participatedIn', value: getRawValueFromOption(opt) })}
        />

        <FormBetweenRange
          isRequired
          label="Between"
          settingDates={settings.betweenDates}
          onSettingChange={onSettingChange}
        />

        <FormForTheseSelect
          label="For These"
          categoriesOptions={settingsDictionaries.membership}
          categoriesValue={getOptionsFromRawValues({
            rawValue: settings.membership,
            options: settingsDictionaries.membership
          })}
          individual={settings.individual}
          onSettingChange={onSettingChange}
        />

        <Row className="mb-2">
          <AdaptiveLabel for="with" className="align-self-start">
            With These
          </AdaptiveLabel>
          <Characteristic
            characteristics={settings.characteristics}
            settingsDictionaries={settingsDictionaries}
            onCharacteristicChange={onCharacteristicChange}
            onCharacteristicAdd={onCharacteristicAdd}
            onCharacteristicValueChange={onCharacteristicValueChange}
            onCharacteristicRemove={onCharacteristicRemove}
          />
        </Row>
      </UILoader>
    </>
  )
}
